import React, { useEffect, useRef, useState } from "react";
import SettingsRow from "@/components/SettingsRow";
import ShowcaseBilling, { billingStateOf } from "@/components/ShowcaseBilling";
import ShowcaseSetup from "@/components/ShowcaseSetup";
import { useShowcase } from "@/hooks/useShowcase";
import { AGENT_SHOWCASE } from "@/services/showcaseService";
import { websiteStatusOf } from "./agentWebsiteModel";
import "./AgentWebsiteRow.scss";

export const agentCheckoutReturnOf = (search) => {
  const params = new URLSearchParams(search || "");
  const outcome = params.get("showcase");
  if (outcome !== "done" && outcome !== "canceled") return null;
  return { outcome, sessionId: params.get("session_id") || "" };
};

const clearReturn = () => {
  const url = new URL(window.location.href);
  ["showcase", "session_id"].forEach((name) => url.searchParams.delete(name));
  window.history.replaceState(
    window.history.state,
    "",
    `${url.pathname}${url.search}${url.hash}`,
  );
};

const AgentWebsiteRow = ({ website = "", name = "" }) => {
  const [checkout, setCheckout] = useState(() =>
    agentCheckoutReturnOf(window.location.search),
  );
  const [open, setOpen] = useState(
    () =>
      Boolean(checkout) ||
      new URLSearchParams(window.location.search).get("row") === "website",
  );
  const query = useShowcase(AGENT_SHOWCASE);
  const showcase = query.data?.showcase;
  const status = websiteStatusOf(query.isError ? null : showcase, website);
  const subscribed = ["active", "comped", "grace"].includes(
    billingStateOf(showcase),
  );
  const rowRef = useRef(null);

  useEffect(() => {
    if (checkout) rowRef.current?.scrollIntoView({ block: "start" });
  }, []);

  return (
    <div className="content-block agent-website-row" ref={rowRef}>
      <SettingsRow
        title="Your website"
        status={
          query.isError ? "Your website settings did not load." : status.line
        }
        actionLabel={status.action}
        open={open}
        onToggle={() => setOpen(!open)}
      >
        {query.isError ? (
          <p className="agent-website-row__state">
            Your website settings did not load.{" "}
            <button
              type="button"
              className="btn btn-link p-0 align-baseline"
              onClick={() => query.refetch()}
            >
              Try again
            </button>
          </p>
        ) : subscribed ? (
          <ShowcaseSetup brokerageId={AGENT_SHOWCASE} brokerageName={name} />
        ) : (
          <ShowcaseSetup
            brokerageId={AGENT_SHOWCASE}
            brokerageName={name}
            previewOnly
          />
        )}
        {query.isError ? null : (
          <ShowcaseBilling
            brokerageId={AGENT_SHOWCASE}
            checkout={checkout}
            onCheckoutHandled={() => {
              clearReturn();
              setCheckout(null);
            }}
            onGo={() => setOpen(true)}
          />
        )}
      </SettingsRow>
    </div>
  );
};

export default AgentWebsiteRow;
